// Maps at-risk flag keys (shared contract with rollup-service) to a chip tone.

const NEG = new Set(['past_due', 'canceled', 'no_activity', 'analysis_backlog', 'onboarding_stalled']);
const WARN = new Set([
  'cancel_scheduled',
  'trial_expiring',
  'seats_full',
  'inactive_users',
  'missing_company_context',
  'single_rep_adoption',
  'no_admin',
  'low_call_quality'
]);
const INFO = new Set(['renewal_soon']);

export type ChipTone = 'neg' | 'warn' | 'info' | '';

export const flagTone = (key: string): ChipTone => {
  if (NEG.has(key)) return 'neg';
  if (WARN.has(key)) return 'warn';
  if (INFO.has(key)) return 'info';
  return '';
};

/** Subscription status -> status pill tone. */
export const statusTone = (status: string): 'pos' | 'warn' | 'neg' => {
  if (['active', 'trialing'].includes(status)) return 'pos';
  if (['past_due', 'grace_period', 'incomplete'].includes(status)) return 'warn';
  if (['canceled', 'unpaid'].includes(status)) return 'neg';
  return 'warn';
};
